import { render, staticRenderFns } from "./myTestPaper.vue?vue&type=template&id=77b4cd5d&scoped=true"
import script from "./myTestPaper.vue?vue&type=script&lang=js"
export * from "./myTestPaper.vue?vue&type=script&lang=js"
import style0 from "./myTestPaper.vue?vue&type=style&index=0&id=77b4cd5d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b4cd5d",
  null
  
)

export default component.exports